import { type ServiceMethod } from '@/application/interfaces/service';
import { type Metadata } from '@/infra/services/model';

export type Response = {
  data: Metadata;
};

const getCategoriesMetadata: ServiceMethod<Response> =
  (httpClient) => async () => {
    const { body: response } = await httpClient.get<Response>(
      '/api/v3/seo/categories/metadata'
    );

    return response;
  };

export default getCategoriesMetadata;
